import React, { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Services from './components/Services';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

const App = () => {
  const [currentPage] = useState('home');

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        {currentPage === 'home' && (
          <>
            <Hero />
            <Features />
            <Services />
            <Pricing />
            <Testimonials />
            <ContactSection />
          </>
        )}
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default App;